/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Whats_New_ErrorInputs */



/**
* | output |
* | --- |
* | "Something went wrong while loading releases." |
*
* @param {Whats_New_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const whats_new_error = /** @type {((inputs?: Whats_New_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Whats_New_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Beim Laden der Releases ist ein Fehler aufgetreten.")
	return /** @type {LocalizedString} */ ("Something went wrong while loading releases.")
});